/**
 * Figma reference metadata for Laboratory stories.
 *
 * Every Laboratory story whose layout mirrors a Figma frame must attach its
 * Figma node id via `parameters: figmaRef(nodeId)`. The diff script in
 * `singularity/.agents/skills/laboratory-design-system/tools/figma-diff/`
 * uses this metadata to fetch the matching Figma PNG and overlay it on a
 * Playwright screenshot.
 *
 * The file key defaults here on purpose — one Figma file backs the Singularity
 * DS, and centralising it prevents drift across DS stories.
 *
 * Product-page stories are the exception: их макеты живут в продуктовых файлах,
 * а не в DS-библиотеке. Такая история передаёт свой ключ явно — `fileKey` в
 * опциях. Дефолт для DS-компонентов при этом не меняется.
 *
 * Source: `UI Kit • Components [Singularity]`
 * URL:    https://www.figma.com/design/g2F0qwj4pSfVwtC6bQ8WLk/
 */
export const FIGMA_FILE_KEY = 'g2F0qwj4pSfVwtC6bQ8WLk';

export interface FigmaRef {
  fileKey: string;
  nodeId: string;
  stripFrameChrome?: boolean;
  darkOnly?: boolean;
  dark?: {
    fileKey?: string;
    nodeId: string;
    stripFrameChrome?: boolean;
  };
}

export function figmaRef(
  nodeId: string,
  options?: { darkNodeId?: string; darkOnly?: boolean; stripFrameChrome?: boolean; fileKey?: string },
): { figma: FigmaRef } {
  return {
    figma: {
      fileKey: options?.fileKey ?? FIGMA_FILE_KEY,
      nodeId,
      stripFrameChrome: options?.stripFrameChrome ?? true,
      // darkOnly: макет существует только в тёмной теме — light-сверка пропускается,
      // dark сверяется с тем же узлом
      ...(options?.darkOnly ? { darkOnly: true, dark: { nodeId } } : {}),
      ...(options?.darkNodeId ? { dark: { nodeId: options.darkNodeId } } : {}),
    },
  };
}
